import React from 'react';
import RaidChallengeBlockView from './RaidChallengeBlock.view';
import { raidInfos } from 'helpers/challenge/raidsInfos';

interface Raid {
  startDate: string;
  endDate: string;
  display: boolean;
  tagLine: string;
  buttonLink: string;
}

const isDateInRange = (date: Date, startDate: Date, endDate: Date): boolean => {
  return date >= startDate && date <= endDate;
};

const getActiveRaid = (raids: Raid[], currentDate: Date): Raid | undefined => {
  return raids.find(raid => {
    const startDate = new Date(raid.startDate);
    const endDate = new Date(raid.endDate);
    return raid.display && isDateInRange(currentDate, startDate, endDate);
  });
};

export const RaidChallengeBlock = () => {
  const currentDate = new Date();
  const activeRaid = getActiveRaid(raidInfos, currentDate);
  if (!activeRaid) return null;
  return (
    <div style={{ width: '100%', marginBottom: '2rem' }}>
      <RaidChallengeBlockView raid={activeRaid} />
    </div>
  );
};

export default RaidChallengeBlock;
